/**
 * Turns arbitrary string-keyed form data into a simple HTML table for notification emails.
 * Keys are escaped; values are stringified and escaped. Omit empty / null / undefined values.
 */
export type ContactEmailData = Record<string, string | number | boolean | null | undefined>;

function escapeHtml(text: string): string {
  return text
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}

function formatLabel(key: string): string {
  const spaced = key.replace(/([a-z])([A-Z])/g, "$1 $2").replace(/[_-]+/g, " ");
  return spaced.replace(/\b\w/g, (c) => c.toUpperCase());
}

export function formatContactEmail(data: ContactEmailData, options?: { title?: string }): string {
  const title = options?.title ?? "Form submission";
  const rows = Object.entries(data)
    .filter(([, v]) => v !== undefined && v !== null && String(v).trim() !== "")
    .map(
      ([key, value]) =>
        `<tr><td style="padding:10px 14px;border:1px solid #e5e5e5;font-weight:600;color:#111;">${escapeHtml(formatLabel(key))}</td><td style="padding:10px 14px;border:1px solid #e5e5e5;color:#333;">${escapeHtml(String(value))}</td></tr>`,
    )
    .join("");

  return `<!DOCTYPE html>
<html lang="en">
<head><meta charset="utf-8"/><meta name="viewport" content="width=device-width,initial-scale=1"/></head>
<body style="margin:0;padding:24px;font-family:system-ui,-apple-system,sans-serif;font-size:15px;line-height:1.5;background:#fafafa;">
  <p style="margin:0 0 16px;font-size:16px;font-weight:600;color:#111;">${escapeHtml(title)}</p>
  <table role="presentation" style="width:100%;max-width:560px;border-collapse:collapse;background:#fff;">${rows}</table>
</body>
</html>`;
}
